module.exports = __webpack_public_path__ + "img/lunyu.04ecd330.jpg";